export default {
  date: 'March 1, 2024',
  title: 'New feature: virtual property tours using vr headset',
  description: '"VR Mode" offers a 360-degree virtual property tour experience through virtual reality headsets.',
  id: 'new-feature',
  jsx: () => (
    <div class='novelty__text'>
      <p>"VR Mode" offers a 360-degree virtual property tour experience through virtual reality headsets.</p>
      <p>Key Features of "VR Mode":</p>
      <b>Immersive 360-Degree Tours:</b>
      <p>With "VR Mode" from Getfloorplan, users can immerse themselves in 360-degree virtual property tours. This means you can virtually navigate every corner of your prospective property, evaluating its spaciousness and ambiance without leaving your office.</p>
      <b>Virtual Reality Headset Compatibility:</b>
      <p>The feature supports modern virtual reality headsets, transforming routine property viewing into an engaging adventure. Oculus, HTC Vive, and other popular VR headsets are seamlessly integrated.</p>
      <b>Detailed Floor Plans:</b>
      <p>Through VR Mode, detailed floor plans and interior designs come to life. Users can virtually "test" the space, moving from room to room, assessing furniture placement and dimensions.</p>
      <p>Now, your clients can fully engage with the world of real estate through "VR Mode" by Getfloorplan!</p>
      <p>Don't miss the opportunity to avail of this feature for free until April 31, 2024, by adding it to your Plus set or Pro set order. Dive into the future today!</p>
    </div>
  ),
  thumb: 'news/6.webp',
};
